import * as Sentry from '@sentry/react';
import { globalToast } from '../components/ui/Toast';
import { ResultadoActividadInciertoError } from './solicitudActividad';

/**
 * Errores que no son culpa del usuario ni tiene forma de corregir: fallas de red,
 * permisos denegados por la base, bugs. Se capturan siempre en Sentry (con la
 * repetición de sesión asociada) y se muestran en un toast que invita a comentar.
 *
 * No usar para errores de validación ("el correo no es válido"): esos van inline
 * en el formulario con handleError, son esperables y no hay nada que reportar.
 *
 * deuda: la cobertura llega a los formularios —lo que escribe en la base— y a las
 * cargas que los alimentan. Fuera de ahí quedan ~57 catch en páginas y hooks que solo
 * hacen console.error: el usuario no ve nada y a Sentry no llega nada.
 * techo: aguanta porque son lecturas de pantallas de consulta — el dato no se corrompe,
 * solo se ve incompleto.
 * disparador: migrarlos cuando llegue el primer reporte de "faltan datos" que no se pueda
 * explicar con los eventos que ya tenemos, o al tocar cualquiera de esos archivos por
 * otro motivo (se migra ese, no los 57).
 */

/** Supabase lanza objetos planos, no instancias de Error: extrae algo legible igual. */
export const detalleTecnico = (e: unknown): string => {
  if (e instanceof Error) return e.message;
  if (typeof e === 'string') return e;
  if (e && typeof e === 'object') {
    const posible = e as { message?: unknown; code?: unknown; details?: unknown; hint?: unknown };
    const partes = [posible.code, posible.message, posible.details, posible.hint]
      .filter((p): p is string => typeof p === 'string' && p.length > 0);
    if (partes.length > 0) return partes.join(' | ');
  }
  return 'Error desconocido';
};

/** Envuelve cualquier valor lanzado en un Error real, para que Sentry agrupe con stack. */
const comoError = (e: unknown): Error =>
  e instanceof Error ? e : new Error(detalleTecnico(e));

export function reportarErrorInesperado(
  e: unknown,
  mensajeUsuario: string,
  contexto?: Readonly<Record<string, unknown>>
): void {
  if (e instanceof ResultadoActividadInciertoError) {
    globalToast.warning(e.message);
    return;
  }
  const eventId = Sentry.captureException(comoError(e), {
    extra: { mensajeUsuario, detalle: detalleTecnico(e), ...contexto },
  });
  globalToast.error(mensajeUsuario, { sentryEventId: eventId });
}
